import React, { useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import Awards from "../components/sections/Awards";
import DataFlows from "../components/sections/DataFlows";
import Features from "../components/sections/Features";
import HelmetWrapper from "../components/sections/HelmetWrapper";
import HomeCase from "../components/sections/HomeCase";
import HomeConnector from "../components/sections/HomeConnector";
// import sections
import Landing from "../components/sections/Landing";
import Partners from "../components/sections/Partners";
import Testimonial from "../components/sections/Testimonial";
import { mainMetaData } from "../seo/metaDeta";
import { outerLink } from "../utils/functions";
import ScrollReveal from "../utils/ScrollReveal";
import { landingPageData } from "../utils/constant";
const { partners } = landingPageData;

const Home = () => {
  const childRef = useRef();
  const history = useHistory();

  useEffect(() => {
    childRef.current.init();
  }, []);

  return (
    <>
      <HelmetWrapper {...mainMetaData} />
      <ScrollReveal
        ref={childRef}
        children={() => (
          <div className="home__box">
            <Landing />
            <Partners images={partners} />
            <HomeCase />
            <DataFlows />
            <HomeConnector
              heading={"Centralize your data in minutes not months"}
              subHeading={
                "150+ fully managed data connectors. All data sources integrated and stored in a cloud data-warehouse."
              }
            />
            <Features />
            {/* <Benifit /> */}
            <Testimonial />
            <Awards />
            <div className="container">
              <div className="trial-box">
                <div className="trial-content reveal-from-left">
                  <div className="ellipse"></div>
                  <div className="text-1 reveal-from-left">
                    Spend more time on data analytics and less time searching
                    for data
                  </div>
                  <div className="text-2 reveal-from-left">
                    Start your free trial today.
                  </div>
                </div>
                <div className="trial-cta reveal-from-right">
                  <button
                    className="button__main button__primary"
                    onClick={() => {
                      history.push("/onestack-data/sign-up");
                    }}
                  >
                    Get Started{" "}
                    <img
                      src={require("../assets/images/long-arrow-right.svg")}
                      alt="arrow"
                    />
                  </button>
                  <button
                    className="button__main button__tertiary"
                    onClick={() =>
                      outerLink(
                        "https://calendly.com/d/dx2-qrw-g8j/hello-datazip"
                      )
                    }
                  >
                    Book a Demo
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      />
    </>
  );
};

export default Home;
